import src from "IMAGE";
export default { src, width: 3722, height: 938, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPklEQVR42g3AsQ2AQAhA0VvTBVQql5DSEYyNxEpshOSY7v5rGw7MUNVdRNYTExa0Bxci4v/g7m9VdTO7MzMGPsUkYnqaU28AAAAASUVORK5CYII="};
